const PersonalInfoStyles = {
  container: {
    p: 3,
  },
  card: {
    p: 3,
    mb: 3,
    border: "1px solid #e0e0e0",
    borderRadius: 1,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },
  cardTitle: {
    fontFamily: "var(--font-noto-sans)",
  },
  cardSubtitle: {
    fontFamily: "var(--font-noto-sans)",
  },
  sectionTitle: {
    mt: 4,
    mb: 2,
    fontFamily: "var(--font-noto-sans)",
  },
  claimantCard: (selected: boolean) => ({
    cursor: "pointer",
    border: selected ? "2px solid #2196f3" : "1px solid #e0e0e0",
    "&:hover": { borderColor: "#2196f3" },
  }),
  claimantCardContent: {
    textAlign: "center",
  },
  claimantIcon: {
    fontSize: 60,
  },
  claimantCardTitle: {
    fontFamily: "var(--font-noto-sans)",
  },
  claimantCardDesc: {
    minHeight: 48,
    fontFamily: "var(--font-noto-sans)",
  },
  gridSection: {
    mb: 4,
  },
};

export default PersonalInfoStyles;
